import { isDevEnv, isStgEnv } from '@sh4res/bo-common/utils/env';

// Keep mock dashboard data for some demo companies
export const shouldMockDashboardData = (companyId: number): boolean => {
  if (isStgEnv() && [376, 409].includes(companyId)) {
    return true;
  }
  if (isDevEnv() && [34, 1215].includes(companyId)) {
    return true;
  }
  return false;
};
